module.exports = __webpack_public_path__ + "img/scenery-tn.42ad5b01.png";